import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipActionOutput = ({
  dataSourceDefinition,
  dataSourceProperty
}) => {
  const {
    label: dataSourceDisplayLabel
  } = dataSourceDefinition;
  const {
    label: propertyDisplayLabel
  } = dataSourceProperty;
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "automation-ui-formula-editor.data-passing-panel.single-value-input.tooltip.action_output_html",
    options: {
      propertyDisplayLabel,
      dataSourceDisplayLabel
    }
  });
};
export default TooltipActionOutput;